import { validateEmail, validateAddress } from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validatePrefix = (values, isMultiRep) => {
    if (values.prefix == null || values.prefix === '') {
        return {
            prefix: isMultiRep
                ? copyFor('validationErrors', 'invalid', 'email')
                : copyFor('validationErrors', 'prefix', 'email')
        };
    }
    return {};
};

const validateTopic = values => {
    if (values.topic == null || values.topic === '') {
        return { topic: copyFor('validationErrors', 'subject', 'email') };
    }
    return {};
};

const validateStreet = values => {
    const addressValidated = validateAddress({ address: values.Street });
    if (addressValidated.address) {
        return { Street: addressValidated.address };
    }
    return {};
};

const validateCity = values => {
    if (values.City == null || values.City === '') {
        return { City: copyFor('validationErrors', 'city', 'email') };
    }
    return {};
};

const validateCounty = values => {
    if (values.County == null || values.County === '') {
        return { County: copyFor('validationErrors', 'county', 'email') };
    }
    return {};
};

const validatePostalCode = values => {
    if (values.Zip == null || values.Zip === '') {
        return { Zip: copyFor('validationErrors', 'postalCode', 'email') };
    }
    return {};
};

const validatePhone = values => {
    if (values.Phone == null || values.Phone === '') {
        return { Phone: copyFor('validationErrors', 'phone', 'email') };
    }
    return {};
};

const validateFullName = values => {
    if (values.fullName == null || values.fullName === '') {
        return { fullName: copyFor('validationErrors', 'fullName', 'email') };
    }
    const split = values.fullName.split(' ');

    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'email') };
};

const validateMessage = values => {
    if (values.message === null || values.message === '') {
        return { message: copyFor('validationErrors', 'message', 'email') };
    }
    return {};
};

const validate = values => {
    const errors = {
        ...validatePrefix(values),
        ...validateFullName(values),
        ...validateEmail(values),
        ...validateMessage(values)
    };

    return errors;
};

export const validateStep1 = values => {
    const errors = {
        ...validateTopic(values, true),
        ...validateMessage(values)
    };

    return errors;
};

export const validateStep2 = values => {
    const errors = {
        ...validateFullName(values),
        ...validateEmail(values),
        ...validatePostalCode(values),
        ...validateStreet(values),
        ...validateCity(values),
        ...validateCounty(values),
        ...validatePhone(values),
        ...validatePrefix(values, true)
    };

    return errors;
};

export default validate;
